import { useMemo } from "react";
import { ProjectType } from "../../entities/projectType";
import {
  useGetProjectTypeQuery,
  useGetProjectTypesQuery,
} from "./projectTypeEndpoints";

export function useProjectType(projectTypeID: number | undefined) {
  const projectTypeQuery = useGetProjectTypeQuery(projectTypeID ?? 0, {
    skip: (projectTypeID ?? 0) <= 0,
  });
  const projectTypeEntity = projectTypeQuery.data;

  return useMemo(() => {
    const ret: typeof projectTypeQuery & {
      projectType?: ProjectType | undefined;
    } = {
      ...projectTypeQuery,
    };
    if (projectTypeEntity) ret.projectType = new ProjectType(projectTypeEntity);
    return ret;
  }, [projectTypeEntity]);
}

export function useProjectTypes() {
  const projectTypeQuery = useGetProjectTypesQuery();
  const projectTypeEntitiesMap = projectTypeQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof projectTypeQuery & {
      projectTypes?: ProjectType[];
      projectTypesMap?: { [id: number]: ProjectType };
    } = {
      ...projectTypeQuery,
      projectTypes: [],
      projectTypesMap: {},
    };
    if (projectTypeEntitiesMap) {
      const projectTypes: ProjectType[] = [];
      const projectTypesMap: { [id: number]: ProjectType } = {};

      for (const key in projectTypeEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(projectTypeEntitiesMap, key)) {
          const c = projectTypeEntitiesMap[key];
          const projectType = new ProjectType(c);
          projectTypes.push(projectType);
          projectTypesMap[projectType.id] = projectType;
        }
      }
      ret.projectTypes = projectTypes;
      ret.projectTypesMap = projectTypesMap;
    }

    return ret;
  }, [projectTypeEntitiesMap]);
}
